var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"test-drive-btn",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[(_vm.miniature)?_c('img',{staticClass:"miniature",attrs:{"src":_vm.miniature,"alt":""}}):_vm._e(),(_vm.isShowVideoIcon)?_c('VideoIcon'):_vm._e(),_c('span',[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }